// admin_document_api.js
import api from './axios';// ודאי שהנתיב לקובץ ה-api.js שלך נכון

/**
 * שליפת כל מסמכי המנהל מהטבלה הכללית
 */
export const getAllAdminDocuments = async () => {
    try {
        const response = await api.get('/admin-documents/all');
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * העלאת מסמך חדש למאגר הכללי
 * @param {File} file - הקובץ הפיזי
 * @param {string} originalName - שם המסמך לתצוגה
 */
export const uploadAdminDocument = async (file, originalName) => {
    try {
        const formData = new FormData();
        // ודאי שהמפתח הראשון הוא 'file'
        formData.append('file', file); 
        formData.append('original_name', originalName);

        const response = await api.post('/admin-documents/upload', formData, {
            headers: {
                // לפעמים אקסיוס צריך הגדרה מפורשת למרות שהוא בדרך כלל מזהה לבד
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * קבלת לינק חתום לצפייה במסמך
 */
export const viewAdminDocument = async (documentId) => {
    try {
        const response = await api.get(`/admin-documents/view/${documentId}`);
        return response.data.url;
    } catch (error) {
        throw error;
    }
};


// קבלת לינק חתום להורדת מסמך

export const downloadAdminDocument = async (documentId) => {
    try {
        const response = await api.get(`/admin-documents/download/${documentId}`);
        return response.data.url;
    } catch (error) {
        throw error;
    }
};


//  * מחיקת מסמך מהמסד ומה-S3
  
export const deleteAdminDocument = async (documentId) => {
    try {
        const response = await api.delete(`/admin-documents/delete/${documentId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};